import _ from "lodash";

const unwrap = (val, ...args) => _.isFunction(val) ? val(...args) : val;

export {
	unwrap,
};
